export enum CompanyDocumentTypeEnum {
    ceidg = 'ceidg',
    krs = 'krs',
}

export type CompanyDocumentType = 'ceidg' | 'krs';
